import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Belgaumtosangliecab() {



    const cardData = {




keyword: "Belgaum to Sangli Taxi",

headingDescription: "Belgaum Taxi Service provides safe, comfortable, and affordable Belgaum to Sangli taxi services for business travel, family visits, medical appointments, educational purposes, shopping trips, corporate travel, and outstation journeys. Whether you require a one-way taxi or a round-trip cab from Belgaum to Sangli, we offer reliable transportation with professional drivers and well-maintained vehicles. Our fleet includes Swift Dzire, Sedan, Ertiga, SUV, Innova, Innova Crysta, Tempo Traveller, and premium cars to meet the needs of individuals, families, corporate clients, and groups. We provide doorstep pickup and drop, flexible travel timings, transparent pricing, easy booking, and 24/7 customer support to make your journey smooth and convenient. Belgaum Taxi Service connects travelers between Belgaum and Sangli with comfortable cab solutions for business meetings, family functions, hospital visits, railway transfers, and personal travel. With experienced chauffeurs, clean vehicles, timely service, and customer-focused assistance, we ensure a safe and enjoyable travel experience. Whether you are traveling for a short visit or planning further trips towards Maharashtra destinations, our Belgaum to Sangli taxi service offers dependable and hassle-free transportation according to your requirements.",

topPlaces: [
  {
    title: "Sangli",
    description: "Sangli is an important city in Maharashtra known for agriculture, industries, sugar production, temples, markets, and cultural heritage. It is a popular destination for business and family travelers from Belgaum."
  },
  {
    title: "Sangli Ganpati Temple",
    description: "Sangli Ganpati Temple is a famous religious attraction known for its spiritual importance, beautiful architecture, and peaceful surroundings. It is visited by devotees throughout the year."
  },
  {
    title: "Dandoba Hills",
    description: "Dandoba Hills is a scenic nature destination near Sangli known for trekking, greenery, wildlife, and peaceful surroundings, making it suitable for weekend trips and nature lovers."
  },
  {
    title: "Kolhapur",
    description: "Kolhapur is a nearby historic city famous for Mahalaxmi Temple, traditional markets, cultural heritage, cuisine, and business activities."
  },
  {
    title: "Panhala Fort",
    description: "Panhala Fort is a famous historical fort near Kolhapur known for Maratha history, scenic views, and peaceful hill surroundings, attracting tourists and history enthusiasts."
  },
  {
    title: "Miraj",
    description: "Miraj is a prominent city near Sangli known for music traditions, healthcare facilities, railway connectivity, and commercial activities."
  },
  {
    title: "Narsobawadi",
    description: "Narsobawadi is a popular pilgrimage destination near Sangli known for the famous Datta Temple and religious importance among devotees."
  },
  {
    title: "Pune",
    description: "Pune is a major IT, education, and industrial hub in Maharashtra with corporate offices, technology parks, universities, and commercial centers."
  },
  {
    title: "Goa",
    description: "Goa is a famous tourist destination known for beaches, resorts, churches, and sightseeing attractions. Many travelers combine Maharashtra and Goa trips with private cab services."
  },
  {
    title: "Mumbai",
    description: "Mumbai is India's financial capital known for business districts, airports, entertainment destinations, and tourist attractions. Private taxis provide comfortable long-distance connectivity."
  }
],




  "services": [
    {
      "name": "Belgaum to Sangli Taxi",
      "description": "Book Belgaum to Sangli Taxi for safe, comfortable, and reliable outstation travel with professional chauffeurs and well-maintained AC vehicles. Enjoy smooth transportation between Belgaum and Sangli with Sedan, Ertiga, Innova Crysta, and SUV taxi options. Our taxi service is suitable for family trips, business travel, personal visits, sightseeing, and long-distance journeys with flexible one way and round trip booking facilities."
    },
    {
      "name": "Belgaum to Sangli Cab",
      "description": "Reserve Belgaum to Sangli Cab for a convenient and comfortable journey with experienced drivers and premium vehicles. Get doorstep pickup, clean AC cars, spacious seating, and affordable travel solutions for your journey. Our cabs are ideal for individuals, families, corporate travelers, and groups travelling between Belgaum and Sangli."
    },
    {
      "name": "Belgaum to Sangli Taxi Service",
      "description": "Choose Belgaum to Sangli Taxi Service for dependable intercity transportation with professional chauffeurs and multiple vehicle options. Travel comfortably with timely pickup, transparent pricing, and well-maintained cars. Our taxi services are perfect for business trips, family travel, sightseeing tours, and personal transportation requirements."
    },
    {
      "name": "Belgaum to Sangli Cab Service",
      "description": "Hire Belgaum to Sangli Cab Service for reliable and comfortable outstation travel. Enjoy premium AC vehicles, experienced drivers, flexible booking options, and convenient pickup facilities. Choose from Sedan, Ertiga, Innova Crysta, and SUV cabs according to your travel needs and passenger capacity."
    },
    {
      "name": "Belgaum to Sangli One Way Cab",
      "description": "Book Belgaum to Sangli One Way Cab for economical single-trip travel without return charges. Get private transportation with professional drivers, comfortable seating, and timely service. One way cab service is suitable for passengers who need direct travel from Belgaum to Sangli at affordable rates."
    },
    {
      "name": "Belgaum to Sangli One Way Taxi",
      "description": "Choose Belgaum to Sangli One Way Taxi for hassle-free point-to-point transportation. Enjoy clean vehicles, skilled chauffeurs, flexible departure timings, and convenient booking options. Perfect for business travel, family visits, medical trips, and personal journeys."
    },
    {
      "name": "Belgaum to Sangli Cab Booking",
      "description": "Complete Belgaum to Sangli Cab Booking with easy reservation facilities and multiple vehicle choices. Select Sedan, Ertiga, Innova Crysta, or SUV cabs according to your comfort and budget. Enjoy professional drivers, doorstep pickup, and smooth travel experience throughout your journey."
    },
    {
      "name": "Belgaum to Sangli Taxi Booking",
      "description": "Book Belgaum to Sangli Taxi Booking services for comfortable and reliable transportation. Get chauffeur-driven taxis with affordable fares, clean interiors, AC facilities, and flexible travel options. Suitable for family trips, corporate travel, sightseeing, and outstation journeys."
    },
    {
      "name": "Belgaum to Sangli Car Rental",
      "description": "Choose Belgaum to Sangli Car Rental services for comfortable chauffeur-driven vehicles. Hire cars for personal travel, business meetings, family trips, and sightseeing requirements. Enjoy well-maintained vehicles, experienced drivers, flexible rental options, and convenient pickup services."
    },
    {
      "name": "Belgaum to Sangli Outstation Cab",
      "description": "Book Belgaum to Sangli Outstation Cab for safe and comfortable long-distance travel. Enjoy reliable transportation with professional chauffeurs, spacious AC vehicles, and flexible trip plans. Our outstation cabs are suitable for families, tourists, business travelers, and groups."
    },
    {
      "name": "Belgaum to Sangli Innova Crysta Cab",
      "description": "Travel with Belgaum to Sangli Innova Crysta Cab for premium comfort and spacious seating. The Innova Crysta is ideal for families, groups, corporate travelers, and passengers carrying extra luggage. Enjoy luxury interiors, smooth rides, and experienced chauffeur service."
    },
    {
      "name": "Belgaum to Sangli Ertiga Cab",
      "description": "Book Belgaum to Sangli Ertiga Cab for affordable and spacious family transportation. Ertiga provides comfortable seating, AC comfort, and luggage space for small groups. Perfect for family tours, airport transfers, corporate travel, and outstation journeys."
    },
    {
      "name": "Belgaum to Sangli Sedan Cab",
      "description": "Choose Belgaum to Sangli Sedan Cab for economical and comfortable travel with professional drivers. Sedan cars are suitable for couples, small families, and business travelers looking for a smooth AC journey. Enjoy clean vehicles, affordable pricing, and reliable service."
    },
    {
      "name": "Belgaum to Sangli Round Trip Cab",
      "description": "Reserve Belgaum to Sangli Round Trip Cab for flexible return travel with affordable packages. Ideal for sightseeing, family visits, business trips, and weekend travel. Enjoy a dedicated vehicle, professional chauffeur, comfortable seating, and convenient scheduling."
    },
    {
      "name": "Belgaum to Sangli Private Taxi",
      "description": "Hire Belgaum to Sangli Private Taxi for a comfortable and personalized travel experience. Enjoy complete privacy with a dedicated vehicle, experienced driver, AC comfort, and flexible travel timings. Suitable for families, couples, corporate passengers, and individual travelers."
    },
    {
      "name": "Cheap Belgaum to Sangli Taxi",
      "description": "Find Cheap Belgaum to Sangli Taxi options with affordable fares and reliable service quality. Choose budget-friendly vehicles without compromising comfort and safety. Enjoy economical Sedan, Ertiga, and other cab options with professional drivers."
    },
    {
      "name": "Best Belgaum to Sangli Taxi Service",
      "description": "Choose Best Belgaum to Sangli Taxi Service for dependable transportation with premium vehicles and skilled chauffeurs. Experience safe journeys, timely pickup, comfortable rides, and flexible booking options for family, business, and personal travel."
    },
    {
      "name": "Online Belgaum to Sangli Cab Booking",
      "description": "Book Online Belgaum to Sangli Cab Booking with simple reservations and quick vehicle selection. Choose your preferred cab category and travel schedule easily. Enjoy online booking convenience, professional drivers, and comfortable outstation travel solutions."
    },
    {
      "name": "Belgaum to Sangli Taxi Fare",
      "description": "Check Belgaum to Sangli Taxi Fare based on vehicle type and travel requirements. Select from Sedan, Ertiga, Innova Crysta, and SUV options with flexible pricing. Get transparent fares, comfortable rides, and reliable chauffeur services."
    },
    {
      "name": "Belgaum to Sangli Car Hire",
      "description": "Hire Belgaum to Sangli Car Hire services for reliable chauffeur-driven transportation. Choose vehicles according to passenger count, luggage needs, and comfort preferences. Ideal for family trips, corporate travel, sightseeing, and personal journeys."
    },
    {
      "name": "Belgaum to Sangli Cab Price",
      "description": "Get affordable Belgaum to Sangli Cab Price options with different vehicle categories and travel packages. Choose economical Sedan cabs or spacious Innova Crysta and SUV vehicles. Enjoy transparent pricing, comfortable journeys, and professional driver assistance."
    },
    {
      "name": "Belgaum to Sangli Family Cab",
      "description": "Book Belgaum to Sangli Family Cab for safe and comfortable travel with your loved ones. Spacious vehicles, experienced chauffeurs, AC comfort, and luggage-friendly interiors ensure a relaxing journey for families travelling between Belgaum and Sangli."
    },
    {
      "name": "Belgaum to Sangli Corporate Taxi",
      "description": "Choose Belgaum to Sangli Corporate Taxi for professional business transportation solutions. Get punctual service, executive vehicles, experienced drivers, and customized travel plans for meetings, employee travel, and corporate requirements."
    },
    {
      "name": "Belgaum to Sangli Airport Transfer",
      "description": "Book Belgaum to Sangli Airport Transfer service for smooth airport pickup and drop transportation. Enjoy timely service, comfortable vehicles, professional chauffeurs, and convenient travel arrangements for business travelers and families."
    },
    {
      "name": "Belgaum to Sangli Cab Fare",
      "description": "Plan your journey with Belgaum to Sangli Cab Fare options based on your preferred vehicle and trip type. Enjoy flexible pricing, comfortable rides, experienced drivers, and reliable transportation services for your outstation travel."
    },
    {
      "name": "Belgaum to Sangli Taxi Near Me",
      "description": "Find Belgaum to Sangli Taxi Near Me services for quick and convenient travel arrangements. Get reliable private taxis with professional drivers, comfortable vehicles, and flexible pickup locations for a smooth journey."
    },
    {
      "name": "Belgaum to Sangli Outstation Taxi",
      "description": "Book Belgaum to Sangli Outstation Taxi for safe and reliable long-distance transportation. Enjoy AC vehicles, spacious seating, experienced chauffeurs, and flexible travel options for families, tourists, corporate passengers, and individual travelers."
    },
    {
      "name": "Belgaum to Sangli Travel by Cab",
      "description": "Enjoy Belgaum to Sangli Travel by Cab with comfortable private transportation and professional driver assistance. Plan your trip with one way or round trip options and experience safe, convenient, and relaxing travel between Belgaum and Sangli."
    }
  ],
  "tableData": [
    ["Belgaum to Sangli Taxi", "Belgaum to Sangli Cab"],
    ["Belgaum to Sangli Taxi Service", "Belgaum to Sangli Cab Service"],
    ["Belgaum to Sangli One Way Cab", "Belgaum to Sangli One Way Taxi"],
    ["Belgaum to Sangli Cab Booking", "Belgaum to Sangli Taxi Booking"],
    ["Belgaum to Sangli Car Rental", "Belgaum to Sangli Outstation Cab"],
    ["Belgaum to Sangli Innova Crysta Cab", "Belgaum to Sangli Ertiga Cab"],
    ["Belgaum to Sangli Sedan Cab", "Belgaum to Sangli Round Trip Cab"],
    ["Belgaum to Sangli Private Taxi", "Cheap Belgaum to Sangli Taxi"],
    ["Best Belgaum to Sangli Taxi Service", "Online Belgaum to Sangli Cab Booking"],
    ["Belgaum to Sangli Taxi Fare", "Belgaum to Sangli Car Hire"],
    ["Belgaum to Sangli Cab Price", "Belgaum to Sangli Family Cab"],
    ["Belgaum to Sangli Corporate Taxi", "Belgaum to Sangli Airport Transfer"],
    ["Belgaum to Sangli Cab Fare", "Belgaum to Sangli Taxi Near Me"],
    ["Belgaum to Sangli Outstation Taxi", "Belgaum to Sangli Travel by Cab"]
  ],





whychoose: [
  {
    WhyChooseheading: "Reliable Belgaum to Sangli Taxi Service",
    WhyChoosedescription: "Travel conveniently from Belgaum to Sangli with a trusted taxi service offering comfortable vehicles, experienced drivers, and flexible travel solutions for a smooth journey."
  },
  {
    WhyChooseheading: "Direct Travel Without Hassle",
    WhyChoosedescription: "Enjoy a private ride with pickup from your preferred location in Belgaum and direct drop service in Sangli without depending on multiple transport options."
  },
  {
    WhyChooseheading: "Cab Options for Every Requirement",
    WhyChoosedescription: "Select from Swift Dzire, Sedan, Ertiga, Innova, Innova Crysta, and SUV cabs according to your passenger count, luggage, and comfort needs."
  },
  {
    WhyChooseheading: "Suitable for Business & Family Trips",
    WhyChoosedescription: "Our Belgaum to Sangli taxis are ideal for office visits, family functions, medical travel, shopping trips, and personal transportation requirements."
  },
  {
    WhyChooseheading: "Professional Drivers for Safe Rides",
    WhyChoosedescription: "Experienced chauffeurs provide smooth driving, timely pickup, and comfortable travel with proper knowledge of the Belgaum to Sangli route."
  },
  {
    WhyChooseheading: "Flexible One Way & Round Trip Plans",
    WhyChoosedescription: "Choose a one-way taxi for direct travel or schedule a return cab according to your preferred timing and journey plan."
  },
  {
    WhyChooseheading: "Comfortable Cars for Every Journey",
    WhyChoosedescription: "Well-maintained vehicles with clean interiors and spacious seating ensure a pleasant travel experience between Belgaum and Sangli."
  },
  {
    WhyChooseheading: "Simple Taxi Booking Support",
    WhyChoosedescription: "Get assistance for vehicle selection, fare details, and cab availability to arrange your Belgaum to Sangli taxi quickly."
  }
]

};

const faqData = [
  {
    question: "Does Belgaum Taxi Service provide Belgaum to Sangli Taxi Service?",
    answer: "Yes, we provide Belgaum to Sangli taxi services with comfortable vehicles and professional drivers for local and outstation travel."
  },
  {
    question: "Can I book a one-way cab from Belgaum to Sangli?",
    answer: "Yes, one-way taxi service is available for passengers who require direct travel between Belgaum and Sangli."
  },
  {
    question: "Which vehicles are available for Belgaum to Sangli travel?",
    answer: "You can choose from Swift Dzire, Sedan, Ertiga, Innova, Innova Crysta, and SUV cabs according to your travel needs."
  },
  {
    question: "Is Belgaum to Sangli taxi suitable for family travel?",
    answer: "Yes, comfortable and spacious vehicles are available for families, senior citizens, and groups travelling between both cities."
  },
  {
    question: "Can I book a return cab from Sangli to Belgaum?",
    answer: "Yes, return journey taxi options are available with flexible schedules based on your travel requirements."
  },
  {
    question: "Do you provide pickup from Belgaum Airport and Railway Station?",
    answer: "Yes, pickup and drop facilities are available from Belgaum Airport, Railway Station, hotels, and other preferred locations."
  },
  {
    question: "Can I hire a private taxi from Belgaum to Sangli?",
    answer: "Yes, private cab services are available with dedicated vehicles and drivers for a comfortable journey."
  },
  {
    question: "Are toll and parking charges included in the taxi fare?",
    answer: "Applicable toll charges, parking fees, and additional travel expenses depend on the selected package and are explained during booking."
  },
  {
    question: "Is Belgaum to Sangli taxi service available 24/7?",
    answer: "Yes, taxi booking assistance is available for planned journeys and urgent travel requirements."
  },
  {
    question: "How can I book a Belgaum to Sangli Taxi?",
    answer: "Share your pickup location, travel date, passenger details, and preferred vehicle type to receive fare details and booking confirmation."
  }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Kiran Joshi",
    feedback: "The Belgaum to Sangli taxi service was smooth and comfortable. The driver was punctual, and the vehicle was clean throughout the journey.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Radhika Patil",
    feedback: "We travelled with family and had a great experience. The cab was spacious, the driver was professional, and the complete trip was well managed.",
    rating: 5
  }
];






    const Images = [
        { place: "/images/keyword/1.jpg", text: "Cab Service in Belgaum", link: "Cab-Service-in-Belgaum" },
        { place: "/images/keyword/2.jpg", text: "Belgaum Taxi Service", link: "Belgaum-Taxi-Service" },
        { place: "/images/keyword/3.jpg", text: "Belgaum to Goa Cab", link: "Belgaum-to-Goa-Cab" },
        { place: "/images/keyword/4.jpg", text: "Belgaum to Mahabaleshwar Cab", link: "Belgaum-to-Mahabaleshwar-Cab" },
        { place: "/images/keyword/5.jpg", text: "Belgaum to Kerala Cab Service", link: "Belgaum-to-Kerala-Cab-Service" },
        { place: "/images/keyword/6.jpg", text: "Goa to Belgaum Cab", link: "Goa-to-Belgaum-Cab" },
        { place: "/images/keyword/7.jpg", text: "Belgaum to Mumbai Cab", link: "Belgaum-to-Mumbai-Cab" },
        { place: "/images/keyword/8.jpg", text: "Belgaum to Bangalore Cab", link: "Belgaum-to-Bangalore-Cab" },
        { place: "/images/keyword/9.jpg", text: "Goa Cab Service", link: "Goa-Cab-Service" },
        { place: "/images/keyword/10.jpg", text: "Taxi Service in Goa", link: "Taxi-Service-in-Goa" },
        { place: "/images/keyword/11.jpg", text: "Cheapest Cab Service in Goa", link: "Cheapest-Cab-Service-in-Goa" },
        { place: "/images/keyword/12.jpg", text: "Corporate Cab Services in Belgaum", link: "Corporate-Cab-Services-in-Belgaum" },
        { place: "/images/keyword/13.jpg", text: "Innova Crysta Rent in Belgaum", link: "Innova-Crysta-Rent-in-Belgaum" },
        { place: "/images/keyword/14.jpg", text: "Ertiga on Rent in Belgaum", link: "Ertiga-on-Rent-in-Belgaum" },
        { place: "/images/keyword/15.jpg", text: "Tempo Traveller Rent in Belgaum", link: "Tempo-Traveller-Rent-in-Belgaum" },
        { place: "/images/keyword/16.jpg", text: "Mini Bus Rental Belgaum", link: "Mini-Bus-Rental-Belgaum" },
        { place: "/images/keyword/17.jpg", text: "Swift Dzire on Rent in Belgaum", link: "Swift-Dzire-on-Rent-in-Belgaum" },
        { place: "/images/keyword/18.jpg", text: "Urbania on Rent in Belgaum", link: "Urbania-on-Rent-in-Belgaum" },
        { place: "/images/keyword/19.jpg", text: "Wedding Car Rental in Belgaum", link: "Wedding-Car-Rental-in-Belgaum" },
        { place: "/images/keyword/20.jpg", text: "Cabs in Belgaum", link: "Cabs-in-Belgaum" },
        { place: "/images/keyword/21.jpg", text: "Belgaum to Hubli Cab", link: "Belgaum-to-Hubli-Cab" },
        { place: "/images/keyword/22.jpg", text: "Belgaum to Dharwad Cab", link: "Belgaum-to-Dharwad-Cab" },
        { place: "/images/keyword/23.jpg", text: "Belgaum to Kolhapur Cab", link: "Belgaum-to-Kolhapur-Cab" },
        { place: "/images/keyword/24.jpg", text: "Belgaum Airport Cab Service", link: "Belgaum-Airport-Cab-Service" },
        { place: "/images/keyword/25.jpg", text: "Belgaum to Bagalkot Cab", link: "Belgaum-to-Bagalkot-Cab" },
    ];









const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Belgaum to Sangli Taxi",
  "image": "https://www.belgaumtaxiservice.com/assets/images/belgaum-to-sangli-taxi.webp",
  "description":
    "Book Belgaum to Sangli Taxi with Belgaum Taxi Service for safe, comfortable, and affordable outstation taxi services. We provide one-way and round-trip cabs from Belgaum to Sangli with Sedan, Ertiga, SUV, Innova, and Innova Crysta cabs available 24x7 for business travel, family trips, airport transfers, and long-distance journeys.",
  "brand": {
    "@type": "Brand",
    "name": "Belgaum Taxi Service"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8517"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://www.belgaumtaxiservice.com/belgaum-to-sangli-taxi"
  }
};



    return (
        <div>

<Helmet>
  <title>Belgaum to Sangli Taxi | One Way Cab Service | +91 8722158435</title>

  <meta
    name="description"
    content="Book Belgaum to Sangli Taxi with Belgaum Taxi Service for reliable one-way and round-trip taxi services. Get affordable cabs from Belgaum to Sangli with Sedan, Ertiga, SUV, Innova, and Innova Crysta for comfortable outstation travel available 24x7."
  />

  <meta
    name="keywords"
    content="Belgaum to Sangli Taxi, Belgaum to Sangli Cab, Belgaum to Sangli Taxi Service, Belgaum to Sangli Cab Service, Belgaum to Sangli One Way Cab, Belgaum to Sangli One Way Taxi, Belgaum to Sangli Cab Booking, Belgaum to Sangli Taxi Booking, Belgaum to Sangli Car Rental, Belgaum to Sangli Outstation Cab"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>








            <div className="page-headder bg-section parallaxie">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="page-header-box text-white">
                                <h1 className="text-anime-style-3 text-center text-white">
                                    {cardData.keyword}
                                </h1>
                            </div>
                        </div>
                    </div>
                </div>
            </div>













            <section>
                <div className="container-fluid p-0" >
                    <div className="row container-fluid px-md-2">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/47.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Belgaum Taxi Service: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>

                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>


                            {/* <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                  
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div> */}


                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div className="service-card" key={index}>
                                        <div className="service-content">
                                            <h4>{service.name}</h4>
                                            <span className="line"></span>
                                            <p>{service.description}</p>
                                        </div>

                                        <div className="service-icon">
                                            <i className="fas fa-arrow-right"></i>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            <div className="keyword-grid">
                                {cardData.tableData.flat().map((keyword, index) => (
                                    <div key={index} className="keyword-item">
                                        <span className="keyword-bullet">-</span>
                                        {keyword}
                                    </div>
                                ))}
                            </div>



                            <div id="why-choose-section" className="why-choose-section">

                                <h2 className="section-title text-dark">
                                    Why Choose <span>Belgaum Taxi Service</span>
                                </h2>

                                <div className="bento-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div className="bento-card" key={index}>

                                            <div className="bento-number">
                                                {String(index + 1).padStart(2, "0")}
                                            </div>

                                            <h4>{item.WhyChooseheading}</h4>

                                            <p>{item.WhyChoosedescription}</p>

                                        </div>
                                    ))}
                                </div>

                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Belgaum Taxi Service </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title=""
                                                    subtitle=""
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fas fa-phone-alt"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+918722158435 " className="pc-call">+91 8722158435 </a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/918722158435 "
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+918722158435 " className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-envelope"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@belgaumtaxiservice.com" className="pc-email">
                                            booking@belgaumtaxiservice.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-location-dot"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Belgaum Taxi Service</strong><br />
                                            P No 30 cCTS No 7023,
                                            Sector No 9 Malmaruti Anjaneya Nagar,
                                            Belgaum, Karnataka - 590017




                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Belgaumtosangliecab ;